import { ENV } from "../utils/env";
import { PaginationProps } from "./Types";

// const baseURL = "http://localhost:8080";
const baseURL = ENV.BASE_URL;

export const Endpoints = {
  GetLogin: () => `${baseURL}/user/auth/login`,
  GetToggleRequireOtp: () => `${baseURL}/user/auth/otp`,
  GetValidateOtpAndLogin: () => `${baseURL}/user/auth/otp/login`,
  GetSendOtpToUser: (email: string) => `${baseURL}/user/auth/otp/${email}`,
  GetSignUp: () => `${baseURL}/user/auth/signup`,
  GetUserProfile: () => `${baseURL}/user/auth/profile`,
  GetGoogleLogin: () => `${baseURL}/user/auth/google`,
  GetValidateCoupon: () => `${baseURL}/user/coupon/check`,
  GetCreateUserCheckout: () => `${baseURL}/user/transaction/checkout`,
  GetPricingArray: () => `${baseURL}/admin/pricing`,
  // Transaction creation now handled by Dodo webhooks
  GetSingleTransaction: (transactionID: string) =>
    `${baseURL}/user/transaction/${transactionID}`,
  GetUserTransactionsWithTemps: (page: number, limit: number) =>
    `${baseURL}/user/transactions?page=${page}&limit=${limit}`,
  GetSingleTemp: (tempID: string) => `${baseURL}/user/temp/${tempID}`,
  GetUnregisteredTemps: () => `${baseURL}/user/temps/unregistered`,
  GetSingleForm: (tempID: string) => `${baseURL}/user/form/${tempID}`,
  GetSubscriptions: ({ page, limit }: PaginationProps) =>
    `${baseURL}/user/subscriptions?page=${page}&limit=${limit}`,
  GetUpdateYoutubeForm: (tempID: string) =>
    `${baseURL}/user/fill-youtube-form/${tempID}`,
  GetSingleSubscriptionWithPlan: (subscriptionID: string) =>
    `${baseURL}/user/subscription/${subscriptionID}`,

  GetCheckoutUserForRenewal: () => `${baseURL}/user/renew/checkout`,
  // GetCheckoutUserForRenewal: () => `${baseURL}/user/renew/offline-checkout`,
  GetRenewUserSubscription: (subscriptionID: string) =>
    `${baseURL}/user/subscription/renew/${subscriptionID}`,

  GetPromoterProfile: () => `${baseURL}/promoter/profile`,
  GetRequestPayout: () => `${baseURL}/promoter/request-payout`,
  GetPromoterTransactions: (page: number, limit: number) =>
    `${baseURL}/promoter/transactions?page=${page}&limit=${limit}`,
  GetPromotersLeaderboard: (page: number, limit: number) =>
    `${baseURL}/promoters/leaderboard?page=${page}&limit=${limit}`,
  GetPromoterPayoutHistory: (page: number, limit: number) =>
    `${baseURL}/promoter/payouts?page=${page}&limit=${limit}`,

  GetCreateNewTicket: () => `${baseURL}/user/ticket/new`,
  GetUserTickets: (page: number, limit: number) =>
    `${baseURL}/user/tickets?page=${page}&limit=${limit}`,
  GetSingleSupportTicket: (ticketID: string) =>
    `${baseURL}/user/ticket/${ticketID}`,
  GetTicketReplies: (ticketID: string) =>
    `${baseURL}/user/ticket/replies/${ticketID}`,
  GetRespondToTicket: (ticketID: string) =>
    `${baseURL}/user/ticket/reply/${ticketID}`,

  GetResendVerificationLink: () => `${baseURL}/user/auth/verify`,
  GetUserVerifyEmail: (verificationID: string, verificationToken: string) =>
    `${baseURL}/user/auth/verify/${verificationID}/${verificationToken}`,

  GetUpdateProfile: () => `${baseURL}/user/auth/profile`,
  GetUpdateEmail: () => `${baseURL}/user/auth/email`,
  GetSendPasswordResetLink: () => `${baseURL}/user/auth/password`,
  GetUpdateUserPassword: () => `${baseURL}/user/auth/password`,
  GetRequestAccountDeletion: (email: string) => `${baseURL}/user/auth/${email}`,
  GetSendEmailFromHomepage: () => `${baseURL}/user/email/send`,
  GetConfirmAccountDeletion: (verificationToken: string) =>
    `${baseURL}/user/auth/confirm/${verificationToken}`,
  GetRecordUserVisit: (origin: string) =>
    `${baseURL}/user/visit?origin=${origin}`,

  GetLoyaltyHistory: (page: number, limit: number) =>
    `${baseURL}/user/loyalty/history?page=${page}&limit=${limit}`,
  GetRedeemLoyaltyPoints: () => `${baseURL}/user/loyalty/redeem`,

  GetUserCart: () => `${baseURL}/user/cart`,
  PutUserCart: () => `${baseURL}/user/cart`,
  DeleteUserCart: () => `${baseURL}/user/cart`,
};
